<template>
<div id="appmenu" v-cloak>

    <Navbar>
    </Navbar>

    <router-view>
    </router-view>

</div>
</template>

<script>
// import axios from 'axios'
// import {
//     NAMESPACE
// } from '../config.js'

import Navbar from '@/components/Navbar'

export default {
    name: 'appmenu',
    components: {
        Navbar: Navbar
    },
    data: function () {
        return {};
    },
    methods: {

    },
    // beforeRouteEnter (to, from, next) {
    //     next(vm => {
    //         alert("beforeRouteEnter")
    //     })
    // },
    // beforeRouteUpdate (to, from, next) {

    //     alert("beforeRouteUpdate")

    //     if ((localStorage.getItem('token') || '') == '') {
    //         this.$router.push('/');
    //     } else {

    //         var token = localStorage.getItem('token');
    //         axios.get(NAMESPACE + 'rest/logged', {
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                     'Authorization': token
    //                 }
    //             })
    //             .then(response => {
    //                 // JSON responses are automatically parsed.
    //                 try {

    //                     if (!response.data.error) {

    //                         if (response.data.token != null) {
    //                             localStorage.setItem('token', response.data.token);
    //                             next();
    //                         } else {
    //                             this.$router.push('/');
    //                         }

    //                     } else {
    //                         //non loggato
    //                         this.$router.push('/');
    //                     }

    //                 } catch (e) {
    //                     this.$router.push('/');
    //                 }

    //             })
    //             .catch(e => {
    //                 this.$router.push('/');
    //             });
    //     }

    // },
    created: function () {
        //alert("push('dashboard'")
        //this.$router.push('/app/dashboard');
    }
}
</script>
